var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"charts"}},[(_vm.chartData)?_c('LineChart',{attrs:{"chartData":_vm.chartData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }